export default function () {
    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('btn-load-team-members')) {
          e.preventDefault();
      
          const self = e.target;
          const target = self.getAttribute('data-target') || '';
      
          if (target) {
            const targetEle = document.querySelector(target);
      
            if (targetEle) {
              fetch(self.getAttribute('data-url'))
                .then((response) => response.text())
                .then((data) => {
                  if (data) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
      
                    // Find the element with the data-next-link attribute
                    const html = tempDiv.querySelector('[data-next-link]');
                    const nextLink = html.getAttribute('data-next-link') || null;
      
                    // Apply filter
                    const filter = targetEle.getAttribute('data-current-filter') || null;
      
                    if (filter && filter !== '*') {
                      html.querySelectorAll('.filter-item').forEach(function (fi) {
                        if (!fi.classList.contains(filter)) {
                          fi.classList.add('hide');
                          fi.style.display = 'none';
                        }
                      });
                    }
      
                    // Update list
                    targetEle.insertAdjacentHTML('beforeend', html.innerHTML);
      
                    // Update link
                    if (nextLink) {
                      self.setAttribute('data-url', nextLink);
                    } else {
                      self.remove();
                    }
                  }
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            }
          }
        }
      });
      
      
  }
  
// /**
//  * Team Member Block
//  */
// $(document).on('click', '.btn-load-team-members', function loadTeamMembers(e) {

//     e.preventDefault();

//     const self = $(this);
//     const target = self.data('target') || '';

//     if (target) {

//         const targetEle = $(target);

//         if (targetEle) {

//             $.ajax({
//                 url: self.attr('data-url'),
//                 success(data) {

//                     if (data) {

//                         const html = $(data);
//                         const nextLink = html.data('next-link') || null;

//                         // apply filter
//                         const filter = targetEle.attr('data-current-filter') || null;

//                         if (filter && filter !== '*') {

//                             html.find('.filter-item').each(function doFilterItems() {

//                                 const fi = $(this);

//                                 if (!fi.hasClass(filter)) {

//                                     fi.addClass('hide');
//                                     fi.hide();

//                                 }

//                             });

//                         }

//                         // update list
//                         targetEle.append(html.html());

//                         // update link
//                         if (nextLink) {

//                             self.attr('data-url', nextLink);

//                         } else {

//                             self.remove();

//                         }

//                     }

//                 },
//             });

//         }

//     }

// });
